(()=>{
  const reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine=window.matchMedia('(pointer:fine)').matches;
  const qa=(s,c=document)=>[...c.querySelectorAll(s)];
  const q=(s,c=document)=>c.querySelector(s);

  function initCinemaZones(root=document){
    const zones=qa('.cinematic-zone:not([data-cine-ready])',root);
    if(!zones.length)return;
    const io=new IntersectionObserver(entries=>{
      entries.forEach(entry=>{
        if(entry.isIntersecting)entry.target.classList.add('is-cine-active');
        else if(entry.intersectionRatio===0)entry.target.classList.remove('is-cine-active');
      });
    },{threshold:.12,rootMargin:'-5% 0px -8%'});
    zones.forEach(zone=>{zone.dataset.cineReady='true';io.observe(zone);});
  }

  function initReactiveMedia(root=document){
    if(reduce || !fine)return;
    qa('[data-cinematic-media]:not([data-cine-pointer-ready])',root).forEach(media=>{
      media.dataset.cinePointerReady='true';
      media.addEventListener('pointermove',e=>{
        const r=media.getBoundingClientRect();
        const x=Math.max(0,Math.min(100,((e.clientX-r.left)/r.width)*100));
        const y=Math.max(0,Math.min(100,((e.clientY-r.top)/r.height)*100));
        media.style.setProperty('--cine-x',`${x}%`);
        media.style.setProperty('--cine-y',`${y}%`);
      });
      media.addEventListener('pointerleave',()=>{
        media.style.setProperty('--cine-x','50%');
        media.style.setProperty('--cine-y','50%');
      });
    });
  }

  function initMagnetic(root=document){
    if(reduce || !fine)return;
    qa('.button:not([data-magnetic-ready]),.circle-arrow:not([data-magnetic-ready])',root).forEach(el=>{
      el.dataset.magneticReady='true';
      el.setAttribute('data-magnetic','');
      el.addEventListener('pointermove',e=>{
        const r=el.getBoundingClientRect();
        const x=(e.clientX-r.left-r.width/2)*.08;
        const y=(e.clientY-r.top-r.height/2)*.11;
        el.style.transform=`translate3d(${x.toFixed(2)}px,${y.toFixed(2)}px,0)`;
      });
      el.addEventListener('pointerleave',()=>{el.style.transform='';});
    });
  }

  function initDropCinema(root=document){
    qa('[data-drop-cinema]:not([data-drop-ready])',root).forEach(cinema=>{
      cinema.dataset.dropReady='true';
      const scenes=qa('[data-drop-scene]',cinema);
      const triggers=qa('[data-drop-trigger]',cinema);
      const progress=q('[data-drop-progress]',cinema);
      if(!scenes.length || !triggers.length)return;
      let active=0,timer=null,raf=null,start=0;
      const duration=5200;
      const autoplay=cinema.dataset.autoplay==='true' && !reduce;
      const setScene=(idx,fromUser=false)=>{
        active=(idx+scenes.length)%scenes.length;
        scenes.forEach((scene,i)=>{
          const yes=i===active;
          scene.classList.toggle('is-active',yes);
          scene.setAttribute('aria-hidden',yes?'false':'true');
        });
        triggers.forEach((trigger,i)=>{
          const yes=i===active;
          trigger.classList.toggle('is-active',yes);
          trigger.setAttribute('aria-selected',yes?'true':'false');
        });
        if(autoplay)restartProgress();
        if(fromUser)cinema.dataset.userDirected='true';
      };
      const stopProgress=()=>{if(raf)cancelAnimationFrame(raf);raf=null;if(timer)clearTimeout(timer);timer=null;};
      const tick=(now)=>{
        const pct=Math.min(100,((now-start)/duration)*100);
        if(progress)progress.style.width=`${pct}%`;
        if(pct<100)raf=requestAnimationFrame(tick);
      };
      const restartProgress=()=>{
        stopProgress();
        if(progress)progress.style.width='0%';
        start=performance.now();
        raf=requestAnimationFrame(tick);
        timer=setTimeout(()=>setScene(active+1),duration);
      };
      triggers.forEach((trigger,i)=>{
        trigger.addEventListener('click',()=>setScene(i,true));
        trigger.addEventListener('mouseenter',()=>{if(fine)setScene(i,true);});
        trigger.addEventListener('focus',()=>setScene(i,true));
      });
      cinema.addEventListener('mouseenter',()=>{if(autoplay)stopProgress();});
      cinema.addEventListener('mouseleave',()=>{if(autoplay)restartProgress();});
      cinema.addEventListener('focusin',()=>{if(autoplay)stopProgress();});
      cinema.addEventListener('focusout',e=>{if(autoplay && !cinema.contains(e.relatedTarget))restartProgress();});
      if(autoplay)restartProgress();
    });
  }

  function initProductFilm(root=document){
    qa('[data-product-film-section]:not([data-film-ready])',root).forEach(section=>{
      section.dataset.filmReady='true';
      const track=q('[data-product-film-track]',section);
      const prev=q('[data-film-prev]',section);
      const next=q('[data-film-next]',section);
      const bar=q('[data-film-progress]',section);
      if(!track)return;
      const amount=()=>Math.max(260,track.clientWidth*.62);
      prev?.addEventListener('click',()=>track.scrollBy({left:-amount(),behavior:reduce?'auto':'smooth'}));
      next?.addEventListener('click',()=>track.scrollBy({left:amount(),behavior:reduce?'auto':'smooth'}));
      const update=()=>{
        const max=Math.max(1,track.scrollWidth-track.clientWidth);
        const pct=Math.max(10,Math.min(100,10+(track.scrollLeft/max)*90));
        if(bar)bar.style.width=`${pct}%`;
      };
      update();
      track.addEventListener('scroll',update,{passive:true});
      window.addEventListener('resize',update,{passive:true});
      if(!reduce && fine){
        let down=false,startX=0,startScroll=0;
        track.addEventListener('pointerdown',e=>{if(e.pointerType==='mouse'){down=true;startX=e.clientX;startScroll=track.scrollLeft;track.setPointerCapture(e.pointerId);track.style.cursor='grabbing';}});
        track.addEventListener('pointermove',e=>{if(down)track.scrollLeft=startScroll-(e.clientX-startX)*1.15;});
        const up=e=>{if(!down)return;down=false;track.style.cursor='';try{track.releasePointerCapture(e.pointerId);}catch(_){} };
        track.addEventListener('pointerup',up);track.addEventListener('pointercancel',up);
      }
    });
  }

  function initHeroDepth(root=document){
    if(reduce || !fine)return;
    qa('.neo-hero:not([data-depth-ready])',root).forEach(hero=>{
      hero.dataset.depthReady='true';
      const media=q('.neo-hero__media',hero), grid=q('.neo-hero__grid',hero);
      hero.addEventListener('pointermove',e=>{
        const r=hero.getBoundingClientRect();
        const x=(e.clientX-r.left)/r.width-.5;
        const y=(e.clientY-r.top)/r.height-.5;
        if(media)media.style.translate=`${(x*9).toFixed(1)}px ${(y*5).toFixed(1)}px`;
        if(grid)grid.style.translate=`${(-x*7).toFixed(1)}px ${(-y*4).toFixed(1)}px`;
      });
      hero.addEventListener('pointerleave',()=>{if(media)media.style.translate='';if(grid)grid.style.translate='';});
    });
  }

  function init(root=document){
    initCinemaZones(root);
    initReactiveMedia(root);
    initMagnetic(root);
    initDropCinema(root);
    initProductFilm(root);
    initHeroDepth(root);
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();
